import { useMemo } from 'react';
import { Button } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import { useConversionActions } from '../../hooks/useConversionActions';
import { EventCard } from '../EventCard/EventCard';
import styles from './conversionEvents.module.scss';

export const ConversionEvents = ({
    conversions,
    existingConversionsToEdit,
    handleEditClick,
    setFocusedConversionId,
    handleStartCreateNewEvent,
}) => {
    const { handleDeleteEvent, getEditTargetStepId } = useConversionActions();

    const existingEventIdsToEdit = useMemo(() => {
        return new Set(existingConversionsToEdit ? existingConversionsToEdit.map(event => event.id) : []);
    }, [existingConversionsToEdit]);

    const handleEditNavigation = eventToEdit => {
        const targetStepId = getEditTargetStepId(eventToEdit.type, eventToEdit);
        handleEditClick(eventToEdit.id, targetStepId);
    };

    return (
        <div className={styles['container']}>
            <div className={styles['events-wrapper']}>
                {conversions.map(event => {
                    const isConsideredExistingForEdit = existingEventIdsToEdit.has(event.id);
                    const isTceEvent = event.eventName?.includes('tce');
                    const isUrlBasedEvent = event.type === CONVERSION_TYPE.BASIC;

                    const canBeEditedBasedOnCriteria = isConsideredExistingForEdit || isTceEvent || isUrlBasedEvent;

                    const finalIsEditDisabled = !canBeEditedBasedOnCriteria;

                    return (
                        <EventCard
                            event={event}
                            key={event.id}
                            setFocusedConversionId={setFocusedConversionId}
                            onEdit={!finalIsEditDisabled ? () => handleEditNavigation(event) : undefined}
                            isEditDisabled={finalIsEditDisabled}
                            onDelete={handleDeleteEvent}
                        />
                    );
                })}
            </div>
            <footer className={styles['footer']}>
                <Button
                    onClick={handleStartCreateNewEvent}
                    variant={Button.variant.primary}
                    size={Button.size.md}
                    aria-label="New Event"
                    className={styles['button']}
                >
                    <span className={styles['plus-icon']}>+</span>
                    <FormattedMessage id="codeless.conversion.event.new.button" defaultMessage="New Event" />
                </Button>
            </footer>
        </div>
    );
};
